import { getUserId, getSvocId, getMemberId } from '../utils/customer';

export const withUserId = <TArgs extends unknown[], TReturn>(
  apiFn: (userId: string, ...args: TArgs) => Promise<TReturn>,
) => {
  return (...args: TArgs): Promise<TReturn> => {
    const userId = getUserId();
    if (!userId) {
      return Promise.reject(new Error('Missing userId'));
    }
    return apiFn(userId, ...args);
  };
};

export const withMemberId = <TArgs extends unknown[], TReturn>(
  apiFn: (memberId: string, ...args: TArgs) => Promise<TReturn>,
) => {
  return (...args: TArgs): Promise<TReturn> => {
    const memberId = getMemberId();
    if (!memberId) {
      return Promise.reject(new Error('Missing memberId'));
    }
    return apiFn(memberId, ...args);
  };
};

export const withSvocId = <TArgs extends unknown[], TReturn>(
  apiFn: (svocId: string, ...args: TArgs) => Promise<TReturn>,
) => {
  return (...args: TArgs): Promise<TReturn> => {
    const svocId = getSvocId();
    if (!svocId) {
      return Promise.reject(new Error('Missing svocId'));
    }
    return apiFn(svocId, ...args);
  };
};

export const withUserContext = <TArgs extends unknown[], TReturn>(
  apiFn: (userId: string, svocId: string, ...args: TArgs) => Promise<TReturn>,
) => {
  return (...args: TArgs): Promise<TReturn> => {
    const userId = getUserId();
    const svocId = getSvocId();
    if (!userId || !svocId) {
      return Promise.reject(new Error('Missing userId or svocId'));
    }
    return apiFn(userId, svocId, ...args);
  };
};

export const withFullUserContext = <TArgs extends unknown[], TReturn>(
  apiFn: (
    userId: string,
    svocId: string,
    memberId: string,
    ...args: TArgs
  ) => Promise<TReturn>,
) => {
  return (...args: TArgs): Promise<TReturn> => {
    const memberId = getMemberId();
    const userId = getUserId();
    const svocId = getSvocId();
    if (!userId || !svocId || !memberId) {
      return Promise.reject(new Error('Missing userId or svocId or memberId'));
    }
    return apiFn(userId, svocId, memberId, ...args);
  };
};

export const withB2BOrB2CId = <TArgs extends unknown[], TReturn>(
  apiFn: (id: string, isB2B: boolean, ...args: TArgs) => Promise<TReturn>,
) => {
  return (isB2B: boolean, ...args: TArgs): Promise<TReturn> => {
    const id = isB2B ? getUserId() : getMemberId();

    if (!id) {
      return Promise.reject(
        new Error(`Missing ${isB2B ? 'userId' : 'memberId'}`),
      );
    }

    return apiFn(id, isB2B, ...args);
  };
};
